
import { defineComponent } from 'vue'
import AppHeader from '@/components/Header.vue'
import appHost from '@/utils/app'

export default defineComponent({
  name: 'Expect-Index',
  components: {
    AppHeader,
  },
  methods: {
    onLeftClick(): void {
      appHost.goAppBack()
    },
  },
})
